import { useMemo } from 'react';

import { collection, Query, query, where } from 'firebase/firestore';

import { useCollectionData } from 'react-firebase-hooks/firestore';

import { useAuth } from '../contextProviders/AuthProvider';
import { firestore } from '../firebase';
import { USGA_POST_BATCH_STATUSES } from '../types/UsgaPostBatch';

import type { UsgaPostBatch } from '../types/UsgaPostBatch';

/** God only: an event's USGA post requests still waiting for, or being run by, the server. */
export default function useEventUsgaPostBatches(orgId: string | undefined, eventId: string | undefined) {
  const { isGod } = useAuth();
  const batchesQuery = useMemo(() => {
    if (!isGod || !orgId || !eventId) return null;
    return query(
      collection(firestore, `org/${orgId}/event/${eventId}/usgaPostBatch`),
      where('status', 'in', [USGA_POST_BATCH_STATUSES.REQUESTED, USGA_POST_BATCH_STATUSES.RUNNING]),
    ) as Query<UsgaPostBatch>;
  }, [isGod, orgId, eventId]);
  const [batches, isLoading, error] = useCollectionData<UsgaPostBatch>(batchesQuery);
  return { pendingBatches: batches ?? [], isLoading, error };
}
